import type { FieldFormatter } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { useComponentStack } from '@/components/core';
import {
  DEFAULT_FORMATTER_CATEGORY,
  findField,
  FormatterConfiguration,
  FormatterMenuItem,
  FORMATTERS,
  NavigationContainer,
  SearchPanel,
  SearchPanelProps,
} from '@/components/ui';
import { useModelConfigStore } from '@/store';
import { generateId } from '@/utils';

export type NewFormatterProps = Omit<SearchPanelProps<FieldFormatter>, 'renderItem' | 'searchableCategorizedData'> & {
  fieldId: string;
};

const INewFormatter = ({ fieldId, className, ...rest }: NewFormatterProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const addFormatter = useModelConfigStore((state) => state.addFormatter);
  const componentStack = useComponentStack();

  return (
    <SearchPanel
      className={className}
      defaultCategory={DEFAULT_FORMATTER_CATEGORY}
      placeholder="Search formatters"
      renderItem={(item) => (
        <FormatterMenuItem
          isDisabled={item.comingSoon}
          onAction={() => {
            const formatter: FieldFormatter = { id: generateId(), ...item };
            addFormatter(fieldId, formatter, field?.parentId);

            componentStack?.push(
              <NavigationContainer>
                <FormatterConfiguration fieldId={fieldId} formatterId={formatter.id} />
              </NavigationContainer>
            );
          }}
          formatter={item}
        />
      )}
      searchableCategorizedData={FORMATTERS}
      {...rest}
    />
  );
};

export const NewFormatter = memo(INewFormatter) as typeof INewFormatter;
